import { CopyText } from "src/components/features/small/CopyText/CopyText";
import { useGlobalLocalContext } from "src/storage/localStorage";

interface AiAssistantThreadIdDebugProps {
  threadId: string | null;
}

/** Debug-mode only: the active Aegra thread ID, for finding it in the DB/logs. */
const AiAssistantThreadIdDebug = ({ threadId }: AiAssistantThreadIdDebugProps) => {
  const isDebugMode = useGlobalLocalContext((state) => state.isDebugMode);

  if (!isDebugMode || !threadId) return null;

  return (
    <div
      className="flex items-center gap-1 pb-2 text-xs text-text-secondary"
      data-test-id="ai-thread-id-debug"
    >
      <span className="shrink-0">Thread</span>
      <CopyText
        text={threadId}
        className="min-w-0 font-mono"
        phContext="ai_thread_id"
      />
    </div>
  );
};

export default AiAssistantThreadIdDebug;
